export default __webpack_public_path__ + "static/media/009-smartwatch.97738061.svg";